import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-insert-label",
  "use": "icon-insert-label-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-insert-label\">\n<rect y=\"1\" width=\"20\" height=\"16\" rx=\"4\" fill=\"#EFAF41\" />\n<path d=\"M10.268 4.66V13H8.9V4.66H10.268Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/insert-label.svg
// module id = 9jJt
// module chunks = 262